import { ContentTypes } from 'academy-shared-js/constants/ContentConstants';
export const APP_NAME = 'learning-center';
export const SCREENS = {
  HOME: 'home-page',
  HUBLESS: 'hubless-error-message',
  LESSON: 'lesson',
  LESSONS: 'lessons-dashboard',
  MY_LEARNING: 'my-learning',
  WATCH_LATER: 'favorites',
  MY_PLAYLISTS: 'my-playlists',
  MY_TEAM: 'my-team',
  TRACK: 'track',
  TRACKS: 'tracks-dashboard',
  PARTNER: 'partner-tracks-dashboard',
  PLAYLIST: 'playlist',
  WIZARD: 'wizard',
  AUTHENTICATED_COURSE_BROCHURE: 'authenticated-course-brochure',
  SHORT: 'short-form'
};
export const SUB_SCREENS = {
  EXAM: 'exam',
  CONCLUSION: 'conclusion',
  RECOMMENDATIONS: 'recommendations'
};
export const TrackingContentTypes = Object.keys(ContentTypes).reduce((obj, key) => {
  const value = key === ContentTypes.PRACTICAL_EXERCISE_FLOW ? 'practical-exercise' : key.toLowerCase();
  return Object.assign({}, obj, {
    [key]: value
  });
}, {});